import { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useTheme } from "@mui/material";
// import { Chart, XAxis, YAxis, Title } from "highcharts";

interface Props {
  monthly_employee_signup: null | any[];
}

const EmployeeChart = (prop: Props) => {
  const theme = useTheme();

  const [months, setMonths] = useState<string[]>([]);
  const [values, setValues] = useState<string[]>([]);
  useEffect(() => {
    if (prop.monthly_employee_signup) {
      setMonths(Object.keys(prop.monthly_employee_signup));
      setValues(Object.values(prop.monthly_employee_signup));
    }
  }, [prop.monthly_employee_signup]);

  let options = {
    chart: {
      type: "column",
      backgroundColor: theme?.palette?.background?.paper,
      color: "white",
    },
    accessibility: {
      description: "New employee chart",
    },
    title: {
      text: "New Employees",
      style: {
        color: theme?.palette?.text?.secondary,
      },
    },
    xAxis: {
      categories: months,
    },
    yAxis: {
      title: {
        text: "No. of employees",
      },
      borderWidth: 10,
    },
    tooltip: {
      pointFormat: "Employees: <b>{point.y:,.0f} </b>",
    },
    plotOptions: {
      area: {
        borderWidth: "10",
        pointStart: 0,
        color: theme?.palette?.text?.secondary,
        marker: {
          enabled: false,
          symbol: "circle",
          radius: 2,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
    },
    series: [
      {
        name: "Months",
        data: values,
      },
    ],
  };
  return (
    <div className="chart_container">
      <div className="subject_chart_container">
        <HighchartsReact
          className="chart"
          highcharts={Highcharts}
          options={options}
        />
      </div>
    </div>
  );
};

export default EmployeeChart;
